import React, { useMemo } from 'react';
import { XButton, XSection } from '@orderx/lab/ui';
import { useActiveOrder } from '../../../hooks/active-order';
import { useZone } from '../../../hooks/zone';
import { MenuProductList } from '../../menu-product/list/MenuProductList';

export function ZoneViewActiveOrder() {
    const zone = useZone();
    const activeOrder = useActiveOrder();

    const menuProducts = useMemo(
        () => zone.getMenu().filter(({ productId }) => activeOrder.getCountByProductId(productId) > 0),
        [zone.response],
    );

    return (
        <>
            <XSection>
                <XButton onClick={activeOrder.resetActiveOrder} fullWidth>
                    Clear order
                </XButton>
            </XSection>

            <XSection>
                <MenuProductList menuProducts={menuProducts} />
            </XSection>
        </>
    );
}
